import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageCircleQuestion } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { Logo } from '@/components/common/Logo';
import { ThemeToggle } from '@/components/common/ThemeToggle';
import { HelpDialog } from '@/components/common/HelpDialog';
import { VersionChip } from '@/components/common/VersionChip';
import { JobsTray } from '@/features/admin/models/JobsTray';
import { MobileNav } from './MobileNav';

export function DashboardTopbar() {
  const { t } = useTranslation('common');
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <header className="flex h-16 shrink-0 items-center justify-end gap-1 border-b border-border bg-background/80 px-4 backdrop-blur md:px-6">
      {/* Mobile-only left cluster: hamburger + brand. `mr-auto` keeps the
          existing controls pinned right; the cluster is removed at `md`,
          where the sidebar provides nav + logo. */}
      <div className="mr-auto flex items-center gap-1 md:hidden">
        <MobileNav />
        <Logo size="md" />
      </div>
      <LanguageSwitcher />
      <ThemeToggle />
      {/* Admin-only async jobs tray — renders null for regular users. */}
      <JobsTray />
      {/* Admin-only build version — likewise renders null for regular users. */}
      <VersionChip />
      <Button
        variant="outline"
        size="sm"
        onClick={() => setHelpOpen(true)}
        title={t('help.openLabel', { defaultValue: 'Get help' })}
        className="ml-2 gap-1.5 rounded-full border-border/60 px-3 text-xs font-medium text-muted-foreground hover:border-primary/40 hover:bg-primary/5 hover:text-foreground"
      >
        <MessageCircleQuestion className="h-3.5 w-3.5" />
        {t('help.openLabel', { defaultValue: 'Get help' })}
      </Button>
      <HelpDialog open={helpOpen} onOpenChange={setHelpOpen} />
    </header>
  );
}
